import React from 'react';
import {
  Stack,
  ModalView,
  Form,
  TextFieldControl,
  withTranslation,
} from '@piwikpro/ui-components';
import { UserGroups, UserGroup } from '@piwikpro/user-groups-crate';
import { TFunction } from 'react-i18next';
import { FormValidator } from '@piwikpro/form-crate';
import { errorBoundary, withInject } from '@piwikpro/platform';
import { RouterService } from '@piwikpro/router-crate';

interface RenameProps {
  filters: any
  userGroups: UserGroups
  userGroup: UserGroup
  validation: FormValidator
  Title: typeof React.Component
  routerService: RouterService
  t: TFunction
}

const Rename: React.FC<RenameProps> = ({
  userGroups,
  userGroup,
  routerService,
  filters,
  Title,
  validation,
  t,
}) => {
  const handleCancel = () => {
    routerService.dismissAdministrationOverlay();
  };

  const handleSubmit = async (values, api) => {
    if (values.name.trim().length > 0) {
      api.setFieldValue('name', values.name.trim(), false);
    } else {
      api.setFieldValue('name', values.name.trim(), true);
    }

    try {
      await userGroups.update(userGroup.id, { name: values.name });

      handleCancel();
      await userGroups.find(filters);
      await userGroups.findOne(userGroup.id);
    } catch (err: any) {
      api.setErrors(err.errors);
      api.setSubmitting(false);
    }
  };

  return (
    <Title
      part={t('user-groups.rename.title', { userGroupName: userGroup.attributes.name })}
      subset
    >
      <Form
        id="rename-user-group-form"
        onSubmit={handleSubmit}
        initialValues={{
          name: userGroup.attributes.name,
        }}
        validationSchema={validation.createValidationSchema(validators => ({
          name: validators.userGroups.name,
        }))}
      >
        <ModalView
          title={t('user-groups.rename.title', { userGroupName: userGroup.attributes.name })}
          actions={(
            <Stack spacing="narrow" horizontalAlignment="right" verticalAlignment="center">
              <Form.Cancel onClick={handleCancel} />
              <Form.Submit />
            </Stack>
          )}
          onClose={handleCancel}
        >
          <TextFieldControl
            name="name"
            required
            autoFocus
            label={t('user-groups.rename.fields.name')}
          />
        </ModalView>
      </Form>
    </Title>
  );
};

export default withInject({
  validation: 'FormCrate.validation',
  userGroups: 'UserGroupsCrate.userGroups',
  Title: 'TitleCrate.components.Title',
  routerService: 'RouterCrate.router',
})(withTranslation(['administration', 'platform'])(errorBoundary(Rename)));
